import classNames from 'classnames';

import Image from '~/components/Image';

import config from '~/config';

import rankingAvatar from '~/assets/images/collections/ranking-avatar.png';
import { ReactComponent as XIcon } from '~/assets/images/iconsLibrary/x.svg';

import styles from './RankingEntryAvatar.module.scss';

export function RankingEntryAvatar({
  avatarUrl,
  alt,
  showRadarIcon = false,
  className,
}: {
  avatarUrl: string;
  alt: string;
  showRadarIcon?: boolean;
  className?: string;
}): JSX.Element {
  return (
    <div className={classNames(styles.imageContainer, className)}>
      <Image
        alt={alt}
        src={
          avatarUrl
            ? `${config.STATIC_RESOURCES_BASE_URL}/${avatarUrl}`
            : rankingAvatar
        }
        height={40}
        width={40}
        className={styles.profileImage}
        onError={(e) => {
          e.currentTarget.src = rankingAvatar;
        }}
      />
      {showRadarIcon && (
        <div className={styles.plus}>
          <XIcon className={styles.icon} />
        </div>
      )}
    </div>
  );
}
